import request from "@/utils/request";

export default function agentGetGroupListByPage(pageNum = 1, size = 10, params) {
    return request({
        url: `/device/deviceGroup/agentGetGroupListByPage/${pageNum}/${size}`,
        params: params
    })
}